import React, { useEffect, useRef, useState } from 'react'
import {
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Button,
    TextField,
    MenuItem,
    Autocomplete,
} from '@mui/material'
import { Formik } from 'formik'
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import SupplierDetailsReport from '../Components/SupplierDetailReportFile'
import xlsx from 'json-as-xlsx';
import DoctorDetailsReport from './DoctorDetailsReport';
import ItemDetailsReport from './ItemDetailsReport';
import DailyStockReportFile from './DailyStockReportFile';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function DailySalesReport() {
    const [pageTitle, setPageTitle] = useState('Daily Sales Report');
    const [searchData, setSearchData] = useState({
        fromDate: new Date().toISOString().substring(0, 10),
        toDate: new Date().toISOString().substring(0, 10),
        shop: 0,
        ItemName: ""
    });
    const [itemList, setItemLIst] = useState([]);
    const [itemName, setItemName] = useState({ ItemName: 'All Items' });
    const [salesDetailList, setSalesDetailList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const componentRef = useRef();

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - salesDetailList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    useEffect(() => {
        GetAllActiveItemDetails();
    }, [])


    function SearchDetails() {
        const searchModel = {
            fromDate: searchData.fromDate,
            toDate: searchData.toDate,
            shop: searchData.shop,
            ItemName: itemName.ItemName == 'All Items' ? null : itemName.ItemName
        }

        console.log("searchModel::> ", searchModel)

        axios.post('https://serverfourpaws.ccsoftwares.com/billing/GetDailySalesDetails', searchModel).then((res) => {
            console.log("res::> ", res.data)
            if (res.data.length > 0) {
                setSalesDetailList(res.data);
            } else {
                setSalesDetailList([]);
                toast.error("No records to display!");
            }
        })
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setSearchData({
            ...searchData,
            [e.target.name]: value
        })
    }

    function GetAllActiveItemDetails() {
        axios.get('https://serverfourpaws.ccsoftwares.com/Item/getAllActiveItemDetails').then((res) => {
            if (res.data.length > 0) {
                setItemLIst(res.data);
            }
        })
    }

    const ClearData = () => {
        setSearchData({
            ...searchData,
            fromDate: new Date().toISOString().substring(0, 10),
            toDate: new Date().toISOString().substring(0, 10),
            shop: 0,
            ItemName: ""
        })
        setItemName({ ItemName: 'All Items' });
        setSalesDetailList([]);
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={12} xs={12}>
                    {titleName}
                </Grid>

            </Grid>
        )
    }

    async function createFile() {
        var file = await createDataFromExcel(salesDetailList);
        var settings = {
            sheetName: 'Daily Sales Report',
            fileName: 'Daily Sales Report',
            writeOptions: {}
        }
        let tempcsvHeaders = csvHeaders;
        tempcsvHeaders.push({ label: 'Invoice Number', value: 'InvoiceNumber' })
        tempcsvHeaders.push({ label: 'Item Name', value: 'ItemName' })
        tempcsvHeaders.push({ label: 'Unit Price', value: 'Unitprice' })
        tempcsvHeaders.push({ label: 'Total Quantity', value: 'TotalQuantity' })
        tempcsvHeaders.push({ label: 'Total Amount (Rs.)', value: 'TotalAmount' })
        tempcsvHeaders.push({ label: 'Sales Date', value: 'SalesDate' })
        let dataA = [
            {
                sheet: 'Daily Sales Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataFromExcel(dataArray) {
        var result = [];
        if (dataArray != null) {
            dataArray.forEach(x => {
                result.push({
                    InvoiceNumber: x.inv_no,
                    ItemName: x.item_name,
                    Unitprice: x.unitprice,
                    TotalQuantity: x.total_quantity,
                    TotalAmount: x.total_amount,
                    SalesDate: x.creation_date
                });
            }
            );
        }
        return result;
    }

    return (
        <>
            <Container maxWidth-={false}>
                <Formik
                    initialValues={{
                        fromDate: searchData.fromDate,
                        toDate: searchData.toDate,
                        shop: searchData.shop,
                    }}

                    onSubmit={() => SearchDetails()}
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Box mt={0}>
                                <Card sx={{ padding: '15px' }}>
                                    <CardHeader
                                        title={cardTitle(pageTitle)}
                                    />
                                    <Divider />
                                    <br />
                                    <Grid container spacing={2}>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                fullWidth
                                                label='From Date'
                                                name="fromDate"
                                                type='date'
                                                onChange={(e) => handleChange(e)}
                                                value={searchData.fromDate}
                                                variant="outlined"
                                                id="fromDate"
                                                size='small'
                                                inputProps={{
                                                    max: new Date().toISOString().split('T')[0]
                                                }}
                                                onKeyPress={(e) => {
                                                    if (e.key >= '0' && e.key <= '9') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                fullWidth
                                                label='To Date'
                                                name="toDate"
                                                type='date'
                                                onChange={(e) => handleChange(e)}
                                                value={searchData.toDate}
                                                variant="outlined"
                                                id="toDate"
                                                size='small'
                                                inputProps={{
                                                    max: new Date().toISOString().split('T')[0]
                                                }}
                                                onKeyPress={(e) => {
                                                    if (e.key >= '0' && e.key <= '9') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                onBlur={handleBlur}
                                                label="Branch Name *"
                                                name='shop'
                                                value={searchData.shop}
                                                id='shop'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                            >
                                                <MenuItem key={0} value={0}>All Branch</MenuItem>
                                                <MenuItem key={4} value={1}>Rathnapura</MenuItem>
                                                <MenuItem key={2} value={2}>Kalawana</MenuItem>
                                                <MenuItem key={3} value={3}>Palmadulla</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item md={5} xs={12}>
                                            <Autocomplete
                                                options={[{ ItemName: 'All Items' }, ...itemList]}
                                                getOptionLabel={(option) =>
                                                    `${option.ItemName}`
                                                }
                                                value={itemName}
                                                onChange={(event, newValue) => {
                                                    setItemName(newValue || { ItemName: 'All Items' });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Item"
                                                        variant='outlined'
                                                        sx={{ flexGrow: 1, marginRight: 1 }}
                                                        size='small'
                                                    />
                                                )}
                                                sx={{ flexGrow: 1, marginRight: 1 }}
                                            />

                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button
                                                variant="contained"
                                                sx={{ width: '150px' }}
                                                onClick={ClearData}
                                            >
                                                clear
                                            </Button>

                                            &nbsp; &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '150px' }}
                                            >
                                                Search
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid container spacing={2}>
                                        <Grid item md={12} xs={12}>
                                            {salesDetailList.length > 0 ?
                                                <TableContainer>
                                                    <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>#</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Invoice Number</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Item Name</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Unit Price</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Quanity</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Total Amount (Rs.)</TableCell>
                                                                <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Sales Date</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {(rowsPerPage > 0
                                                                ? salesDetailList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                : salesDetailList).map((row, index) => (
                                                                    <TableRow key={row._id}>
                                                                        <TableCell align='left'>{index + 1}</TableCell>
                                                                        <TableCell align='left'>{row.inv_no}</TableCell>
                                                                        <TableCell align='left'>{row.item_name}</TableCell>
                                                                        <TableCell align='left'>{row.unitprice}</TableCell>
                                                                        <TableCell align='left'>{row.total_quantity}</TableCell>
                                                                        <TableCell align='left'>{row.total_amount}</TableCell>
                                                                        <TableCell align='left'>{row.creation_date}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            {emptyRows > 0 && (
                                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                                    <TableCell colSpan={5} />
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                        <TableFooter>
                                                            <TableRow>
                                                                <TablePagination
                                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                    colSpan={8}
                                                                    count={salesDetailList.length}
                                                                    rowsPerPage={rowsPerPage}
                                                                    page={page}
                                                                    slotProps={{
                                                                        select: {
                                                                            inputProps: {
                                                                                'aria-label': 'rows per page',
                                                                            },
                                                                            native: true,
                                                                        },
                                                                    }}
                                                                    onPageChange={handleChangePage}
                                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                                    ActionsComponent={TablePaginationActions}
                                                                />
                                                            </TableRow>
                                                        </TableFooter>
                                                    </Table>
                                                </TableContainer>
                                                : null}
                                            {salesDetailList.length > 0 ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        onClick={createFile}
                                                        size="small"
                                                    >
                                                        EXCEL
                                                    </Button>
                                                    <div>&nbsp;</div>
                                                    {/* <ReactToPrint
                                                        documentTitle={'Daily Sales Report'}
                                                        trigger={() => (
                                                            <Button
                                                                color="primary"
                                                                type="button"
                                                                variant="contained"
                                                                size='small'
                                                            >
                                                                PDF
                                                            </Button>
                                                        )}
                                                        content={() => componentRef.current}
                                                    /> */}
                                                    <div hidden={true}>
                                                        <DailyStockReportFile
                                                            ref={componentRef}
                                                            salesDetailList={salesDetailList}
                                                        />
                                                    </div>
                                                </Box>
                                                : null}
                                        </Grid>
                                    </Grid>

                                </Card>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Container >


        </>
    )
}

export default DailySalesReport